import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getCatalogTakeawayOpenState } from 'store/ProductCatalog/takeaway/selectors';
import { safeLazy } from 'utils/safeLazy';

const CatalogTakeawayPopup = safeLazy(
  () => import(/* webpackChunkName: "CatalogTakeawayPopup" */ '../CatalogTakeawayPopup'),
);

const CatalogTakeawayPopupGuard = ({ isOpen }) => (isOpen ? <CatalogTakeawayPopup /> : null);

CatalogTakeawayPopupGuard.propTypes = {
  isOpen: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isOpen: getCatalogTakeawayOpenState(state),
});

export default connect(mapStateToProps)(CatalogTakeawayPopupGuard);
